<template>
  <div>
    <a-layout class="main-layout">
      <!-- 左侧菜单 -->
      <a-layout-sider
        v-model="collapsed"
        collapsible
        :trigger="null"
        width="250"
        class="main-layout-sider"
        :style="{ background: '#1a1f35' }"
      >
        <div class="logo">
          <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" :style="{ height: collapsed ? '40px' : '55px', width: 'auto', objectFit: 'contain' }">
        </div>
        <a-menu
          theme="light"
          mode="inline"
          :selected-keys="[activeMenu]"
          :open-keys="openKeys"
          @openChange="handleOpenChange"
          @select="handleMenuSelect"
          :style="{ height: '100%', borderRight: 0, background: 'transparent' }"
        >
          <!-- 控制面板主菜单 -->
          <a-sub-menu key="dashboard">
            <span slot="title">
              <a-icon type="dashboard" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.auth }}</span>
            </span>
            <!-- 子菜单 -->
          <a-menu-item key="base">
            <a-icon type="home" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.auth }}</span>
          </a-menu-item>
          <a-menu-item key="sub-account">
            <a-icon type="user" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.subAccount }}</span>
          </a-menu-item>
          <a-menu-item key="traffic">
            <a-icon type="line-chart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.traffic }}</span>
          </a-menu-item>
          <a-menu-item key="login-record">
            <a-icon type="clock-circle" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.loginRecord }}</span>
          </a-menu-item>
          <a-menu-item key="flow-record">
            <a-icon type="wallet" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.flowRecord }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- 购买大菜单 -->
        <a-sub-menu key="purchase">
          <span slot="title">
              <a-icon type="shopping-cart" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.dynamicResidential }}</span>
            </span>
          <a-menu-item key="purchase">
            <a-icon type="credit-card" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.buyPlan }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- 静态住宅大菜单 -->
        <a-sub-menu key="staticnux">
          <span slot="title">
              <a-icon type="home" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.staticResidential }}</span>
            </span>
          <a-menu-item key="staticnux">
            <a-icon type="file-text" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidential }}</span>
          </a-menu-item>
          <a-menu-item key="staticnux-purchase">
            <a-icon type="shopping-cart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidentialNative }}</span>
          </a-menu-item>
          <a-menu-item key="staticnux-broadcast-purchase">
            <a-icon type="shopping-cart" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticResidentialBroadcast }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- 工具大菜单 -->
        <a-sub-menu key="utiltools">
          <span slot="title">
              <a-icon type="tool" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.tools }}</span>
            </span>
          <a-menu-item key="utiltools-qrcode">
            <a-icon type="qrcode" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.qrcodeGenerator }}</span>
          </a-menu-item>
          <a-menu-item key="utiltools-proxy-tester">
            <a-icon type="appstore" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.proxyTester }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- API文档大菜单 -->
        <a-sub-menu key="api-docs">
          <span slot="title">
              <a-icon type="book" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.apiDocs }}</span>
            </span>
          <a-menu-item key="api-docs-dynamic">
            <a-icon type="api" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.dynamicApi }}</span>
          </a-menu-item>
          <a-menu-item key="api-docs-static">
            <a-icon type="file-done" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.staticApi }}</span>
          </a-menu-item>
        </a-sub-menu>
        
        <!-- 个人中心大菜单 -->
        <a-sub-menu key="user">
          <span slot="title">
              <a-icon type="user" :style="{ fontSize: '16px' }" />
              <span style="font-size: '14px'">{{ t.userCenter }}</span>
            </span>
          <a-menu-item key="settings">
            <a-icon type="setting" :style="{ fontSize: '14px' }" />
            <span style="font-size: '14px'">{{ t.userSettings }}</span>
          </a-menu-item>
        </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      
      <!-- 主内容区域 -->
      <a-layout>
        <!-- 顶部导航 -->
        <a-layout-header class="main-layout-header">
          <!-- 左侧菜单切换按钮 -->
          <a-button
            type="text"
            icon="menu-unfold"
            @click="collapsed = !collapsed"
            :style="{ fontSize: '16px', width: '64px', height: '64px' }"
          />
          
          <!-- 中间空白区域 -->
          <div class="header-middle"></div>
          
          <!-- 右侧导航 -->
          <div class="header-right">
            <!-- 语言切换 -->
            <a-dropdown>
              <div class="language-switch">
                <a-icon type="global" :style="{ fontSize: '16px' }" />
                <span class="language-text">{{ currentLanguage }}</span>
                <a-icon type="down" :style="{ marginLeft: '4px', fontSize: '12px' }" />
              </div>
              <a-menu slot="overlay" @click="handleLanguageChange">
                <a-menu-item key="zh-CN">
                  <span>简体中文</span>
                </a-menu-item>
                <a-menu-item key="en-US">
                  <span>English</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            
            <!-- 登录状态显示 -->
            <template v-if="isLoggedIn">
              <a-dropdown>
              <div class="user-info">
                <a-avatar :size="32">
                  <a-icon slot="icon" type="user" />
                </a-avatar>
                <span class="username">{{ userName }}</span>
                <a-icon type="down" :style="{ marginLeft: '8px' }" />
              </div>
              <a-menu slot="overlay">
                <!-- <a-menu-item @click="handleUserProfile">
                  <a-icon type="user" />
                  <span>个人资料</span>
                </a-menu-item> -->
                <a-menu-item @click="handleSettings">
                  <a-icon type="setting" />
                  <span>{{ t.personalSettings }}</span>
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item @click="handleLogout">
                  <a-icon type="logout" />
                  <span>{{ t.logout }}</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            </template>
          </div>
          
        </a-layout-header>
        
        <!-- 内容区域 -->
        <a-layout-content class="main-layout-content">
          <router-view />
        </a-layout-content>
        
        <!-- 页脚 -->
        <!-- <a-layout-footer class="main-layout-footer">
          ProxyLink ©2026 All Rights Reserved
        </a-layout-footer> -->
      </a-layout>
    </a-layout>
    
    <!-- 悬浮客服按钮 -->
    <div id="kefu" style="position: fixed; bottom: 40px; right: 40px; z-index: 999;">
      <label slot="reference" class="topBtn" @click="Kefu()" :title="t.customerService" style="cursor: pointer; display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; border-radius: 50%; background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); color: white; font-size: 24px; box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4); transition: all 0.3s ease;">
        <a-icon type="customer-service" />
      </label>
    </div>
    
    <!-- 客服弹窗 -->
    <a-modal
        v-model="visible"
        :title="t.customerService"
        :footer="null"
        width="600px"
        :maskClosable="true"
      >
      <div style="display: flex;align-items: center;padding: 20px 0" v-for="item in FormatList" :key="item.id">
        <div style="display: flex;align-items: center;">
          <span>{{ t.contactType }} :</span> <a :href='item.link'> {{ item.contact }}</a>
        </div>
        <div class="QrcodeWrap" v-if="item.contacttype == 'wechat' || item.contacttype == 'qq'" style="margin-left: 20px;">
          <qrcode-vue :value="item.contact"  :size="size" level="L" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return {
      collapsed: false,
      openKeys: ['dashboard'],
      savedOpenKeys: ['dashboard'], // 保存展开状态，用于折叠/展开切换
      activeMenu: 'base',
      // 登录状态相关
      isLoggedIn: false,
      userName: '',
      // 语言切换相关
      currentLanguage: 'English',
      languageCode: 'en', // 用于传递给子组件的语言代码
      languageMap: {
        'zh-CN': '简体中文',
        'en-US': 'English'
      },
      // 客服相关
      visible: false,
      FormatList: [],
      size: 100,
      userId: localStorage.getItem('userId') || '',
      // 页面文本国际化配置
      i18n: {
        en: {
          // 侧边栏菜单
          auth: 'Account Auth',
          subAccount: 'Sub Accounts',
          traffic: 'Traffic Usage',
          loginRecord: 'Login Records',
          flowRecord: 'Recharge Records',
          dynamicResidential: 'Dynamic Residential',
          buyPlan: 'Buy Plan',
          staticResidential: 'Static Residential',
          staticResidentialNative: 'Static Native',
          staticResidentialBroadcast: 'Static Broadcast',
          tools: 'Tools',
          qrcodeGenerator: 'QR Code',
          proxyTester: 'Proxy Tester',
          apiDocs: 'API Docs',
          dynamicApi: 'Dynamic API',
          staticApi: 'Static API',
          userCenter: 'User Center',
          userSettings: 'Settings',
          // 顶部导航和下拉菜单
          personalSettings: 'Settings',
          logout: 'Logout',
          customerService: 'Customer Service',
          contactType: 'Contact Type'
        },
        zh: {
          // 侧边栏菜单
          auth: '账密认证',
          subAccount: '子账号管理',
          traffic: '流量使用概括',
          loginRecord: '登录记录',
          flowRecord: '流量充值记录',
          dynamicResidential: '动态住宅',
          buyPlan: '购买套餐',
          staticResidential: '静态住宅',
          staticResidentialNative: '静态住宅原生购买',
          staticResidentialBroadcast: '静态住宅广播购买',
          tools: '工具',
          qrcodeGenerator: '二维码生成',
          proxyTester: '代理测试',
          apiDocs: '接口文档',
          dynamicApi: '动态API',
          staticApi: '静态API',
          userCenter: '个人中心',
          userSettings: '个人设置',
          // 顶部导航和下拉菜单
          personalSettings: '个人设置',
          logout: '退出登录',
          customerService: '客服',
          contactType: '联系方式'
        }
      }
    };
  },
  
  // 提供语言状态给子组件
  provide() {
    return {
      languageState: this
    };
  },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageCode;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  mounted() {
    // 根据当前路由设置激活的菜单项
    this.setActiveMenu();
    // 检查登录状态
    this.checkLoginStatus();
  },
  watch: {
    // 监听路由变化，更新激活的菜单项
    $route() {
      this.setActiveMenu();
      // 路由变化时重新检查登录状态
      this.checkLoginStatus();
    },
    
    // 监听菜单折叠/展开状态，控制子菜单的显示
    collapsed(newVal) {
      if (newVal) {
        // 折叠时保存当前展开状态，并清空openKeys
        this.savedOpenKeys = [...this.openKeys];
        this.openKeys = [];
      } else {
        // 展开时恢复之前的展开状态
        this.openKeys = [...this.savedOpenKeys];
      }
    }
  },
  methods: {
    // 处理菜单展开/折叠
    handleOpenChange(openKeys) {
      this.openKeys = openKeys;
      // 同步更新保存的展开状态
      this.savedOpenKeys = [...openKeys];
    },
    
    // 处理菜单选择
    handleMenuSelect({ key }) {
      this.activeMenu = key;
      
      // 根据选择的菜单项跳转到对应的路由
      let targetRoute = '';
      switch (key) {
        case 'base':
          targetRoute = '/dashboard/base';
          break;
        case 'sub-account':
          targetRoute = '/dashboard/sub-account';
          break;
        case 'traffic':
          targetRoute = '/dashboard/traffic';
          break;
        case 'login-record':
          targetRoute = '/dashboard/login-record';
          break;
        case 'flow-record':
          targetRoute = '/dashboard/flow-record';
          break;
        case 'purchase':
          targetRoute = '/purchase/buy';
          break;
        case 'staticnux':
          targetRoute = '/staticnux/index';
          break;
        case 'staticnux-purchase':
          targetRoute = '/staticnux/purchase';
          break;
        case 'staticnux-broadcast-purchase':
          targetRoute = '/staticnux/broadcast-purchase';
          break;
        case 'utiltools-qrcode':
          targetRoute = '/utiltools/qrcode';
          break;
        case 'utiltools-proxy-tester':
          targetRoute = '/utiltools/proxy-tester';
          break;
        case 'api-docs-dynamic':
          targetRoute = '/api-docs/dynamic';
          break;
        case 'api-docs-static':
          targetRoute = '/api-docs/static';
          break;
        case 'settings':
          targetRoute = '/user/settings';
          break;
        default:
          targetRoute = '/dashboard/base';
      }
      
      // 避免冗余导航警告
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    
    // 根据当前路由设置激活的菜单项
    setActiveMenu() {
      const path = this.$route.path;
      switch (path) {
        // dashboard相关路由
        case '/dashboard/base':
          this.activeMenu = 'base';
          this.openKeys = ['dashboard'];
          break;
        case '/dashboard/sub-account':
          this.activeMenu = 'sub-account';
          this.openKeys = ['dashboard'];
          break;
        case '/dashboard/traffic':
          this.activeMenu = 'traffic';
          this.openKeys = ['dashboard'];
          break;
        case '/dashboard/login-record':
          this.activeMenu = 'login-record';
          this.openKeys = ['dashboard'];
          break;
        case '/dashboard/flow-record':
          this.activeMenu = 'flow-record';
          this.openKeys = ['dashboard'];
          break;
        // 购买相关路由
        case '/purchase/buy':
          this.activeMenu = 'purchase';
          this.openKeys = ['purchase'];
          break;
        // 静态住宅菜单相关路由
        case '/staticnux/index':
          this.activeMenu = 'staticnux';
          this.openKeys = ['staticnux'];
          break;
        case '/staticnux/purchase':
          this.activeMenu = 'staticnux-purchase';
          this.openKeys = ['staticnux'];
          break;
        case '/staticnux/broadcast-purchase':
          this.activeMenu = 'staticnux-broadcast-purchase';
          this.openKeys = ['staticnux'];
          break;
        // 工具相关路由
        case '/utiltools/qrcode':
          this.activeMenu = 'utiltools-qrcode';
          this.openKeys = ['utiltools'];
          break;
        case '/utiltools/proxy-tester':
          this.activeMenu = 'utiltools-proxy-tester';
          this.openKeys = ['utiltools'];
          break;
        // API文档相关路由
        case '/api-docs/dynamic':
          this.activeMenu = 'api-docs-dynamic';
          this.openKeys = ['api-docs'];
          break;
        case '/api-docs/static':
          this.activeMenu = 'api-docs-static';
          this.openKeys = ['api-docs'];
          break;
        // 用户设置相关路由
        case '/user/settings':
          this.activeMenu = 'settings';
          this.openKeys = ['user'];
          break;
        default:
          this.activeMenu = 'base';
          this.openKeys = ['dashboard'];
      }
    },
    
    // 检查登录状态
    checkLoginStatus() {
      const token = localStorage.getItem('Token') || localStorage.getItem('Authorization');
      const userName = localStorage.getItem('userName');
      this.isLoggedIn = !!token;
      this.userName = userName || '用户';
    },
    
    // 个人资料
    handleUserProfile() {
      // 可以跳转到个人资料页面
      console.log('查看个人资料');
    },
    
    // 账户设置
    handleSettings() {
      // 可以跳转到个人设置页面
      this.$router.push('/user/settings');
    },
    
    // 退出登录
    handleLogout() {
      // 清除localStorage中的登录信息
      localStorage.removeItem('Token');
      localStorage.removeItem('Authorization');
      localStorage.removeItem('userName');
      localStorage.removeItem('userId');
      localStorage.removeItem('subNumber');
      
      // 更新登录状态
      this.isLoggedIn = false;
      this.userName = '';
      
      // 跳转到登录页面
      this.$router.push('/login');
      
      // 显示退出成功提示
      this.$message.success('退出登录成功');
    },
    
    // 处理语言切换
    handleLanguageChange({ key }) {
      this.currentLanguage = this.languageMap[key];
      // 更新语言代码，用于传递给子组件
      this.languageCode = key === 'zh-CN' ? 'zh' : 'en';
      // 这里可以添加实际的语言切换逻辑，比如调用i18n插件的方法
      console.log('切换语言为:', key, '语言代码:', this.languageCode);
    },
    
    // 获取客服联系方式
    getCommentsDataList() {
      // 更新userId，确保获取最新的用户ID
      this.userId = localStorage.getItem('userId') || '';
      this.$request.get("/contact/selectAgentContact?userId=" + this.userId).then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    
    // 打开客服弹窗
    Kefu() {
      this.getCommentsDataList();
      this.visible = true;
    }
  }
};
</script>

<style scoped>
/* 重置和基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 全局布局样式 - 确保不溢出，无滚动条 */
.main-layout {
  min-height: 100vh;
  background: #f0f2f5;
  overflow: hidden; /* 防止整体溢出 */
  display: flex;
  flex-direction: row;
}

/* 侧边栏样式优化 - 固定高度，无溢出 */
.main-layout-sider {
  background: #f5f7fa !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden !important;
  height: 100vh !important;
  position: fixed !important;
  left: 0;
  top: 0;
  z-index: 100;
}

/* Logo样式优化 - 简化设计 */
.logo {
  height: 48px;
  margin: 16px;
  /* background: rgba(255, 255, 255, 0.8); */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  backdrop-filter: blur(10px);
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}

.logo-text {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 菜单容器 - 固定高度，无溢出 */
.ant-menu {
  height: calc(100vh - 80px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* 隐藏滚动条 */
.ant-menu::-webkit-scrollbar {
  width: 4px;
}

.ant-menu::-webkit-scrollbar-track {
  background: transparent;
}

.ant-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

/* 菜单项样式优化 - 现代化设计，增强视觉层次感 */
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  padding: 0 16px !important;
  height: 44px !important;
  line-height: 44px !important;
  margin: 2px 8px !important;
  border-radius: 8px !important;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  position: relative;
  font-size: 14px !important;
  font-weight: 450 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  border: 1px solid transparent;
  box-sizing: border-box;
  width: calc(100% - 16px);
}

/* 菜单项悬停效果 - 增强视觉反馈 */
.ant-menu-dark.ant-menu-inline .ant-menu-item:hover,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border-color: rgba(255, 255, 255, 0.15);
}

/* 菜单项选中效果 - 突出显示 */
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%) !important;
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
  transform: translateX(4px);
  border-color: rgba(255, 255, 255, 0.2);
}

.ant-menu-dark.ant-menu-inline .ant-menu-item-selected::after {
  display: none !important;
}

/* 菜单项文字样式 - 增强对比度 */
.ant-menu-dark.ant-menu-inline .ant-menu-item > span,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title > span {
  font-size: 14px !important;
  font-weight: 450 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  letter-spacing: 0.3px;
}

/* 选中项文字样式 - 突出显示 */
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected > span {
  color: white !important;
  font-weight: 600 !important;
}

/* 子菜单项样式 - 优化缩进和对齐 */
.ant-menu-dark.ant-menu-inline .ant-menu-item {
  padding-left: 48px !important;
  width: calc(100% - 16px);
  box-sizing: border-box;
}

/* 菜单项样式优化 - 确保长文本正常显示 */
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

/* 菜单项图标样式 - 增强视觉效果 */
.ant-menu-dark.ant-menu-inline .ant-menu-item i,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title i {
  font-size: 16px !important;
  margin-right: 12px !important;
  color: rgba(255, 255, 255, 0.95) !important;
  transition: all 0.3s ease;
}

/* 浅色主题菜单项样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item,
.ant-menu-light.ant-menu-inline .ant-menu-submenu-title {
  padding: 0 16px !important;
  height: 44px !important;
  line-height: 44px !important;
  margin: 2px 8px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 450 !important;
  width: calc(100% - 16px);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 主菜单（一级菜单项）样式 - 突出显示 */
.ant-menu-light.ant-menu-inline .ant-menu-submenu-title {
  background: linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%) !important;
  color: #1890ff !important;
  font-weight: 550 !important;
  border: 1px solid rgba(24, 144, 255, 0.1) !important;
}

/* 主菜单悬停效果 */
.ant-menu-light.ant-menu-inline .ant-menu-submenu-title:hover {
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%) !important;
  color: #096dd9 !important;
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

/* 主菜单图标样式 */
.ant-menu-light.ant-menu-inline .ant-menu-submenu-title i {
  color: #1890ff !important;
  font-size: 16px !important;
  margin-right: 12px !important;
}

/* 主菜单文字样式 */
.ant-menu-light.ant-menu-inline .ant-menu-submenu-title span {
  color: #1890ff !important;
  font-weight: 550 !important;
}

/* 浅色主题子菜单项样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item {
  background: transparent !important;
  color: #333 !important;
  font-weight: 450 !important;
  border: 1px solid transparent !important;
  transition: all 0.3s ease;
}

/* 浅色主题子菜单项悬停效果 */
.ant-menu-light.ant-menu-inline .ant-menu-item:hover {
  background: #fafafa !important;
  color: #1890ff !important;
  transform: translateX(2px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 浅色主题子菜单项选中效果 */
.ant-menu-light.ant-menu-inline .ant-menu-item-selected {
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%) !important;
  color: #096dd9 !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.2);
}

/* 浅色主题子菜单图标样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item i {
  color: #666 !important;
  font-size: 14px !important;
  margin-right: 12px !important;
  transition: all 0.3s ease;
}

/* 浅色主题子菜单悬停/选中状态的图标样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item:hover i,
.ant-menu-light.ant-menu-inline .ant-menu-item-selected i {
  color: #1890ff !important;
  transform: scale(1.05);
}

/* 浅色主题子菜单文字样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item span {
  color: #333 !important;
  transition: all 0.3s ease;
}

/* 浅色主题子菜单悬停/选中状态的文字样式 */
.ant-menu-light.ant-menu-inline .ant-menu-item:hover span,
.ant-menu-light.ant-menu-inline .ant-menu-item-selected span {
  color: #096dd9 !important;
  font-weight: 500 !important;
}

/* 选中项图标样式 */
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected i {
  color: white !important;
  transform: scale(1.1);
}

/* 子菜单展开/折叠图标样式 */
.ant-menu-dark .ant-menu-submenu-arrow {
  color: rgba(255, 255, 255, 0.7) !important;
  transition: all 0.3s ease;
}

.ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
  color: white !important;
  transform: rotate(180deg);
}

/* 菜单分组标题样式 */
.ant-menu-dark .ant-menu-submenu-title {
  font-weight: 600 !important;
}

/* 主内容区域 - 固定布局，无溢出 */
.ant-layout-content {
  background: #f0f2f5 !important;
  min-height: 100vh;
  padding: 0 !important;
  margin-left: 250px !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航栏样式优化 - 固定高度，无溢出 */
.main-layout-header {
  background: #fff;
  padding: 0 24px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 10;
  height: 64px;
  border-bottom: 1px solid #f0f0f0;
  overflow: hidden;
  flex-shrink: 0;
}

/* 左侧菜单切换按钮样式 - 简化 */
.ant-layout-header .ant-btn {
  transition: all 0.2s ease;
  border-radius: 6px;
  background: transparent;
  border: 1px solid transparent;
  color: #666;
  width: 40px !important;
  height: 40px !important;
  font-size: 14px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-layout-header .ant-btn:hover {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #1890ff;
}

/* 中间空白区域 */
.header-middle {
  flex: 1;
}

/* 右侧导航样式 - 现代化布局，增强用户体验 */
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

/* 语言切换样式 */
.language-switch {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 22px;
  cursor: pointer;
  background: #ffffff;
  border: none;
  color: inherit;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.language-switch:hover {
  background: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.language-text {
  font-size: 14px;
  font-weight: 550;
  color: #262626;
  white-space: nowrap;
}

/* 用户信息样式 - 简约设计 */
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 22px;
  cursor: pointer;
  background: #ffffff;
  border: none;
  color: inherit;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: none;
}

.user-info:hover {
  background: #ffffff;
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transform: none;
}

.user-info:active {
  transform: none;
  background: #ffffff;
}

/* 用户名样式 - 简约显示 */
.user-info .username {
  font-size: 14px;
  font-weight: 550;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  transition: none;
}

.user-info:hover .username {
  color: #262626;
}

/* 头像样式 - 简约设计 */
.ant-avatar {
  flex-shrink: 0;
  transition: none;
  border: 2px solid transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.user-info:hover .ant-avatar {
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transform: none;
}

/* 下拉箭头样式 */
.user-info .anticon-down {
  transition: none;
  font-size: 12px;
  color: #666666;
}

.user-info:hover .anticon-down {
  color: #666666;
  transform: none;
}

/* 下拉菜单样式优化 */
.ant-dropdown-menu {
  border-radius: 12px !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #f0f0f0 !important;
  overflow: hidden;
}

/* 下拉菜单项样式 */
.ant-dropdown-menu-item {
  padding: 10px 20px !important;
  height: auto !important;
  line-height: 20px !important;
  transition: all 0.2s ease !important;
  font-size: 14px !important;
}

.ant-dropdown-menu-item:hover {
  background: linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%) !important;
  color: #1890ff !important;
}

/* 下拉菜单项图标样式 */
.ant-dropdown-menu-item .anticon {
  font-size: 14px !important;
  margin-right: 8px !important;
  transition: all 0.2s ease;
}

.ant-dropdown-menu-item:hover .anticon {
  color: #1890ff !important;
  transform: scale(1.1);
}

/* 下拉菜单分割线样式 */
.ant-dropdown-menu-divider {
  margin: 4px 0 !important;
  background-color: #f5f5f5 !important;
}

/* 内容区域样式优化 - 固定高度，内部滚动 */
.main-layout-content {
  margin: 16px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0; /* 允许内容区域收缩 */
}

/* 内容区域滚动条样式 */
.main-layout-content::-webkit-scrollbar {
  width: 6px;
}

.main-layout-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.main-layout-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.main-layout-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 页脚样式优化 - 固定高度，无溢出 */
.main-layout-footer {
  text-align: center;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 12px 0;
  margin: 0 16px 16px;
  color: #666;
  font-size: 12px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
  overflow: hidden;
}

/* 右侧主内容区域的布局 - 适配侧边栏 */
.main-layout > .ant-layout {
  margin-left: 250px;
  width: calc(100% - 250px);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 响应式设计优化 - 适配小屏幕 */
@media (max-width: 768px) {
  .main-layout-sider {
    position: absolute !important;
    z-index: 1000;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.2);
  }
  
  .main-layout > .ant-layout {
    margin-left: 0;
    width: 100%;
  }
  
  .ant-layout-content {
    margin-left: 0 !important;
  }
  
  .main-layout-content {
    margin: 12px;
    padding: 16px;
    border-radius: 6px;
  }
  
  .header-right {
    gap: 4px;
  }
  
  .user-info {
    gap: 6px;
    padding: 4px 8px;
  }
  
  .user-info .username {
    font-size: 12px;
    max-width: 80px;
  }
  
  .main-layout-footer {
    margin: 0 12px 12px;
    padding: 8px 0;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .main-layout-content {
    margin: 8px;
    padding: 12px;
  }
  
  .logo-text {
    font-size: 16px;
  }
  
  .main-layout-footer {
    margin: 0 8px 8px;
  }
}

/* 收缩状态下的样式 */
.main-layout-sider.ant-layout-sider-collapsed {
  width: 80px !important;
}

.main-layout-sider.ant-layout-sider-collapsed + .ant-layout {
  margin-left: 80px !important;
  width: calc(100% - 80px) !important;
}

.ant-layout-content {
  margin-left: 80px !important;
}

.main-layout-sider.ant-layout-sider-collapsed + .ant-layout .ant-layout-content {
  margin-left: 0 !important;
}
</style>